import { render, staticRenderFns } from "./IdeaHomePage.vue?vue&type=template&id=8faa2c6e&scoped=true"
import script from "./IdeaHomePage.vue?vue&type=script&lang=js"
export * from "./IdeaHomePage.vue?vue&type=script&lang=js"
import style0 from "./IdeaHomePage.vue?vue&type=style&index=0&id=8faa2c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faa2c6e",
  null
  
)

export default component.exports